import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Users, Sparkles, ChevronRight } from "lucide-react";

export const ContactStrip = () => {
  return (
    <section data-testid="contact-strip-section" className="pt-[35px] pb-[35px] md:py-20 bg-[#1677FF] relative overflow-hidden">
      {/* Decorative shapes */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-20 -left-20 w-60 h-60 rounded-full bg-white/5"></div>
        <div className="absolute -bottom-16 -right-16 w-80 h-80 rounded-full bg-white/5"></div>
        <div className="absolute top-10 right-[20%] w-20 h-20 rounded-2xl bg-white/5 rotate-12"></div>
      </div>

      <div className="relative mx-auto w-full max-w-[var(--container-max)] px-4 sm:px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center md:text-left"
          >
            <h2 className="text-2xl sm:text-3xl font-bold text-white tracking-tight mb-4">
              Ready to Start Your Child's Coding Journey?
            </h2>
            <div className="flex flex-wrap items-center gap-3 justify-center md:justify-start">
              {[
                { icon: Sparkles, text: "Online Classes" },
                { icon: Users, text: "Small Classes" },
                { icon: Sparkles, text: "Free Trial Available" },
              ].map((item) => (
                <span key={item.text} className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold bg-white/15 text-white">
                  <item.icon className="w-3 h-3" />
                  {item.text}
                </span>
              ))}
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
          >
            <Link to="/contact">
              <Button
                size="lg"
                className="rounded-full bg-white text-[#1677FF] hover:bg-white/90 btn-lift px-8 h-12 text-base font-bold shadow-xl"
              >
                Book a Free Trial
                <ChevronRight className="w-4 h-4 ml-1" />
              </Button>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ContactStrip;
